import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import _ from "lodash";
import * as UTIL from '../../util';
var Creators = Actions.Creators;
var pageChangeSearch = Creators.pageChange;
var termChangeSearch = Creators.termChange;
var topicsChangeSearch = Creators.topicsChange;
var categoriesChangeSearch = Creators.categoriesChange;
var priceChangeSearch = Creators.priceChange;
var requestSearch = Creators.request;
var receiveSearch = Creators.response;
var pageSizeSearch = Creators.pageSizeChange;
var dataSourceChangeSearch = Creators.dataSourceChange;
var sortByChangeSearch = Creators.sortByChange;
var clearRail = Creators.clearRail;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

var handleRepeatParam = function handleRepeatParam(label, array) {
  return array.length > 0 ? "&".concat(label, "=").concat(array.join()) : "";
};

function fetchSearch(state, pageSizeParent) {
  return function (dispatch) {
    var _state$location, _state$location$locat, _state$location2, _state$location2$loca, _state$location3, _state$location3$loca;

    var searchTerm = state.search.searchTerm;

    if (!searchTerm) {
      return;
    }

    dispatch(requestSearch());
    dispatch(clearRail());
    var currentPage = state.search.currentPage + 1;
    var pageSize = pageSizeParent !== null && pageSizeParent !== void 0 ? pageSizeParent : state.search.pageSize;
    var dataSource = state.search.dataSource ? "&datasource=".concat(state.search.dataSource) : "";
    var categories = handleRepeatParam("Categories", state.search.categories);
    var topics = handleRepeatParam("topics", state.search.topics);
    var price = handleRepeatParam("priceRange", state.search.price);
    var order = state.search.order ? "&sortOrder=".concat(state.search.order) : "";
    var sortBy = state.search.sortBy ? "&sortBy=".concat(state.search.sortBy) : "";
    var foodIds = Boolean(state === null || state === void 0 ? void 0 : (_state$location = state.location) === null || _state$location === void 0 ? void 0 : (_state$location$locat = _state$location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.olo_unique_name) ? "&cateringStoreId=".concat(state === null || state === void 0 ? void 0 : (_state$location2 = state.location) === null || _state$location2 === void 0 ? void 0 : (_state$location2$loca = _state$location2.location) === null || _state$location2$loca === void 0 ? void 0 : _state$location2$loca.olo_catering_unique_name, "&storeId=").concat(state === null || state === void 0 ? void 0 : (_state$location3 = state.location) === null || _state$location3 === void 0 ? void 0 : (_state$location3$loca = _state$location3.location) === null || _state$location3$loca === void 0 ? void 0 : _state$location3$loca.olo_unique_name) : "";
    var params = "searchterm=".concat(searchTerm, "&currentPage=").concat(currentPage, "&pageSize=").concat(pageSize).concat(topics).concat(sortBy).concat(order).concat(categories).concat(dataSource).concat(sortBy).concat(foodIds).concat(price);
    return UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.getSearch, "?").concat(params)).then(function (json) {
      var pascal = UTIL.toPascal(json);

      if (pascal.Facets.length > 0) {
        pascal.Facets = pascal.Facets.map(function (category) {
          return _objectSpread(_objectSpread({}, category), {}, {
            Values: category.Values.map(function (value) {
              return {
                Name: value.Name,
                Count: value.Count,
                Value: state.search[category.Name.toLowerCase()].indexOf(value.Name) !== -1
              };
            })
          });
        });
      }

      dispatch(receiveSearch(pascal));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

var pageChange = function pageChange(pageNumber) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(pageChangeSearch({
      currentPage: pageNumber
    }));
    return dispatch(fetchSearch(getState()));
  };
};

var termChange = function termChange(searchTerm, pageSize) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(termChangeSearch({
      searchTerm: searchTerm || state.searchTerm
    }));
    return dispatch(fetchSearch(getState(), pageSize));
  };
};

var setPageSize = function setPageSize(pageSize) {
  return function (dispatch, getState) {
    var state = getState();
    return dispatch(pageSizeSearch({
      pageSize: pageSize || state.searchTerm
    }));
  };
};

function arrayRemove(arr, value) {
  return arr.filter(function (ele) {
    return ele != value;
  });
}

var topicChange = function topicChange(topic, isAdd) {
  return function (dispatch, getState) {
    var state = getState();
    var results;

    if (isAdd) {
      results = [].concat(_toConsumableArray(state.search.topics), [topic]);
    } else {
      results = arrayRemove(state.search.topics, topic);
    }

    dispatch(topicsChangeSearch({
      topics: results
    }));
    dispatch(pageChangeSearch({
      currentPage: 0
    }));
    return dispatch(fetchSearch(getState()));
  };
};

var categoriesChange = function categoriesChange(category, isAdd) {
  return function (dispatch, getState) {
    var state = getState();
    var results;

    if (isAdd) {
      results = [].concat(_toConsumableArray(state.search.categories), [category]);
    } else {
      results = arrayRemove(state.search.categories, category);
    }

    dispatch(categoriesChangeSearch({
      categories: results
    }));
    dispatch(pageChangeSearch({
      currentPage: 0
    }));
    return dispatch(fetchSearch(getState()));
  };
};

var priceChange = function priceChange(price, isAdd) {
  return function (dispatch, getState) {
    var state = getState();
    var results;

    if (isAdd) {
      results = [].concat(_toConsumableArray(state.search.price), [price]);
    } else {
      results = arrayRemove(state.search.price, price);
    }

    dispatch(priceChangeSearch({
      price: results
    }));
    dispatch(pageChangeSearch({
      currentPage: 0
    }));
    return dispatch(fetchSearch(getState()));
  };
};

var setDataSource = function setDataSource(dataSource) {
  return function (dispatch) {
    return dispatch(dataSourceChangeSearch({
      dataSource: dataSource
    }));
  };
};

var sortByChange = function sortByChange(sortBy) {
  return function (dispatch, getState) {
    dispatch(sortByChangeSearch({
      sortBy: sortBy
    }));
    return dispatch(fetchSearch(getState()));
  };
};

export default {
  fetchSearch: fetchSearch,
  receiveError: receiveError,
  receiveSearch: receiveSearch,
  pageChange: pageChange,
  termChange: termChange,
  topicChange: topicChange,
  categoriesChange: categoriesChange,
  priceChange: priceChange,
  setPageSize: setPageSize,
  setDataSource: setDataSource,
  sortByChange: sortByChange,
  clearRail: clearRail
};